import React, { useImperativeHandle, useRef, useState } from "react";
import ExtensionReasonsDialog from "@icoach/documents/membership/dialog/ExtensionReasonsDialog";
import GiftReasonsDialog from "@icoach/documents/membership/dialog/GiftReasonsDialog";
import MembershipBillingRecordDialog from "@icoach/documents/membership/dialog/MembershipBillingRecordDialog";
import MembershipRecordDialog from "@icoach/documents/membership/dialog/MembershipRecordDialog";
import SuspendReasonsDialog from "@icoach/documents/membership/dialog/SuspendReasonsDialog";
import EnhanceCyclePurchasePromptDialog from "@icoach/documents/membership/dialog/EnhanceCyclePurchasePromptDialog";
import QuitAllRentCabinetDialog from "@icoach/rentCabinet/dialog/QuitAllRentCabinetDialog";
import { isEqual, isFunction } from "@util/utils";


const EXTENSION_REASONS_DIALOG = "ExtensionReasonsDialog";
const GIFT_REASONS_DIALOG = "GiftReasonsDialog";
const MEMBERSHIP_BILLING_RECORD_DIALOG = "MembershipBillingRecordDialog";
const MEMBERSHIP_RECORD_DIALOG = "MembershipRecordDialog";
const SUSPEND_REASONS_DIALOG = "SuspendReasonsDialog";
const ENHANCE_CYCLE_PURCHASE_PROMPT_DIALOG = "EnhanceCyclePurchasePromptDialog";
const QUIT_ALL_RENT_CABINET_DIALOG = "QuitAllRentCabinetDialog";


const MembershipDocumentDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState("");
	const [sourceData, setSourceData] = useState(null);
	const refreshRef = useRef(null);

	const handleDialogClose = () => {
		setOpenDialog(null);
		setSourceData(null);
	};

	const doRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) {
			setTimeout(() => refreshRef.current(...arg), 5);
		}
	};

	useImperativeHandle(
		ref,
		() => ({
			openExtensionReasonsDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(EXTENSION_REASONS_DIALOG);
			},
			openGiftReasonsDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(GIFT_REASONS_DIALOG);
			},
			openMembershipBillingRecordDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(MEMBERSHIP_BILLING_RECORD_DIALOG);
			},
			openMembershipRecordDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(MEMBERSHIP_RECORD_DIALOG);
			},
			openSuspendReasonsDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(SUSPEND_REASONS_DIALOG);
			},
			openEnhanceCyclePurchasePromptDialog: (targetDate, refreshFn, redirectToPage) => {
				refreshRef.current = refreshFn;
				setSourceData({...targetDate, redirectToPage});
				setOpenDialog(ENHANCE_CYCLE_PURCHASE_PROMPT_DIALOG);
			},
			openQuitAllRentCabinetDialog: (targetDate, refreshFn) => {
				refreshRef.current = refreshFn;
				setSourceData(targetDate);
				setOpenDialog(QUIT_ALL_RENT_CABINET_DIALOG);
			},
			closeDialog: () => {
				handleDialogClose();
			},
		}),
		// eslint-disable-next-line
		[]
	);

	return (
		<React.Fragment>
			<ExtensionReasonsDialog open={isEqual(openDialog, EXTENSION_REASONS_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} memberID={sourceData?.memberID} membershipID={sourceData?.membershipID} />
			<GiftReasonsDialog open={isEqual(openDialog, GIFT_REASONS_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} memberID={sourceData?.memberID} membershipID={sourceData?.membershipID} />
			<MembershipBillingRecordDialog open={isEqual(openDialog, MEMBERSHIP_BILLING_RECORD_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} memberID={sourceData?.memberID} membershipID={sourceData?.membershipID} />
			<MembershipRecordDialog open={isEqual(openDialog, MEMBERSHIP_RECORD_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} memberID={sourceData?.memberID} membershipID={sourceData?.membershipID} />
			<SuspendReasonsDialog open={isEqual(openDialog, SUSPEND_REASONS_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} memberID={sourceData?.memberID} membershipID={sourceData?.membershipID} />
			<EnhanceCyclePurchasePromptDialog open={isEqual(openDialog, ENHANCE_CYCLE_PURCHASE_PROMPT_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} redirectToPage={sourceData?.redirectToPage} />
			<QuitAllRentCabinetDialog open={isEqual(openDialog, QUIT_ALL_RENT_CABINET_DIALOG)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} memberID={sourceData?.memberID} />
		</React.Fragment>
	);
});

export default MembershipDocumentDialogBox;
